import { jsonHeaders, jsonResult } from "./index.js";
import { BACKEND_PREFIX as backendPrefix } from "#src/env.js";
import { profile } from "#src/stores/auth.js";

let $profile;
profile.subscribe((value) => {
  $profile = value;
});

async function searchCrmContacts({ search_string }) {
  const orgid = $profile.organization_id;

  const res = await fetch(`${backendPrefix}/crm/${orgid}/search-contacts/`, {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify({ search_string }),
  });

  return jsonResult(res);
}

async function addCrmContact(contact) {
  const orgid = $profile.organization_id;

  const res = await fetch(`${backendPrefix}/crm/${orgid}/contacts`, {
    method: "POST",
    headers: jsonHeaders(),
    body: JSON.stringify({ contact }),
  });

  return jsonResult(res);
}

export { searchCrmContacts, addCrmContact };
